import { Record } from 'immutable';

const ConnectionHistoryItemRecord = Record({
  finished: true,
  id: 0,
  integration: '',
  percentage: 0,
  updatedAt: new Date().getTime(),
  createdAt: new Date().getTime(),
  message: '',
});

export default class ConnectionHistoryItem extends ConnectionHistoryItemRecord {
  static deserialize(jsonObject = {}) {
    return new ConnectionHistoryItem(jsonObject);
  }

  static EXPIRES_IN = 300000; // 5 minutes

  get isExpired() {
    const now = new Date().getTime();

    if (this.percentage === 100) {
      return false;
    }

    return now - this.updatedAt > ConnectionHistoryItem.EXPIRES_IN;
  }
}
